export default "__VITE_ASSET__BuhUyJ1n__"